import { Question } from './question.js';

export class SingleSelectQuestion extends Question {
    renderContent() {
        this.ctx.elementIds.push('answerOptionsElement' + this.question.id);
        let answer = [];
        answer[0] = '';
        let answerName = [];
        let questionAnswers = this.ctx.changeAnswerOptionsSequence(this.question.answers, this.question.randomType);

        let answerOptionsElement = document.createElement('div');
        answerOptionsElement.style.marginTop = '16px';
        answerOptionsElement.classList.add('ph-options');
        answerOptionsElement.id = 'answerOptionsElement' + this.question.id;

        let internalBox = document.createElement('div');
        internalBox.classList.add('ph-survey__inner');
        internalBox.setAttribute('role', 'radiogroup');
        internalBox.setAttribute('aria-labelledby', 'ph-title-' + this.question.id);
        this.answerContainer = internalBox;
        answerOptionsElement.appendChild(internalBox);

        if (questionAnswers.length > 6) {
            internalBox.style.padding = '0 12px 0px 0px';
        }

        questionAnswers.forEach((option, index) => {
            if (option.type === 'normal' && option.content !== null) {
                let answerOption = document.createElement('div');
                let label = document.createElement('label');
                label.htmlFor = 'answer' + this.ctx.currentIndex + index;
                label.textContent = option.content;
                label.style.textAlign = 'left';
                answerOption.classList.add('ph-option');
                let input = document.createElement('input');
                input.type = 'radio';
                input.classList.add('ph-input--radio');
                input.id = 'answer' + this.ctx.currentIndex + index;
                input.name = 'answer';
                input.value = option.content;

                answerOption.setAttribute('tabindex', '0');
                input.setAttribute('tabindex', '-1');
                answerOption.addEventListener('keydown', (e) => {
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        answerOption.click();
                    }
                });

                answerOption.appendChild(input);
                answerOption.appendChild(label);

                answerOption.onclick = (event) => {
                    if (event.target !== input && event.target !== label) {
                        input.checked = true;
                        input.dispatchEvent(new Event('click'));
                    }
                };

                input.onclick = () => {
                    if (answer[0] === '') {
                        answer[0] = option.content;
                        answerName = option.content;
                    } else {
                        input.checked ? answer[0] = option.content : answer[0] = '';
                        input.checked ? answerName = option.content : answerName = '';
                    }
                    setTimeout(() => {
                        this.ctx.goNext(this.question, answer[0]);
                    }, 250);
                };
                internalBox.appendChild(answerOption);

            } else if (option.type === 'other') {
                let answerOption = document.createElement('div');
                let label = document.createElement('label');
                label.htmlFor = 'answer' + this.ctx.currentIndex + index;
                label.textContent = option.name;
                label.style.textAlign = 'left';
                answerOption.classList.add('ph-option');
                label.id = 'label' + 'single_select' + this.question.id + index;
                let radioButton = document.createElement('input');
                radioButton.type = 'radio';
                radioButton.classList.add('ph-input--radio');
                radioButton.id = 'radiobutton_answer' + this.ctx.currentIndex + index;
                radioButton.name = 'answer';
                radioButton.value = '';

                answerOption.setAttribute('tabindex', '0');
                radioButton.setAttribute('tabindex', '-1');
                answerOption.addEventListener('keydown', (e) => {
                    if (e.target !== answerOption) return;
                    if (e.key === 'Enter' || e.key === ' ') {
                        e.preventDefault();
                        answerOption.click();
                    }
                });

                answerOption.appendChild(radioButton);
                answerOption.appendChild(label);

                answerOption.onclick = (event) => {
                    if (event.target !== radioButton) {
                        radioButton.checked = true;
                        radioButton.dispatchEvent(new Event('click'));
                    }
                };

                radioButton.onclick = () => {
                    if (radioButton.checked) {
                        let input = this.ctx.getById(this.shadowRoot, 'answer' + this.ctx.currentIndex + index);
                        if (input) {
                            input.focus();
                        }
                    }
                    if (radioButton.value) {
                        radioButton.checked ? answer[0] = radioButton.value : answer[0] = '';
                        radioButton.checked ? answerName = option.name : answerName = '';
                    }

                    const labelEl = this.ctx.getById(this.shadowRoot, 'label' + 'single_select' + this.question.id + index);
                    if (labelEl) {
                        labelEl.style.display = 'none';
                    }
                    if (answerOption.childNodes.length < 3) {
                        let input = document.createElement('input');
                        input.classList.add('ph-input--text-inline');
                        input.type = 'text';
                        input.id = 'answer' + this.ctx.currentIndex + index;
                        input.name = 'answer';
                        input.placeholder = option.placeholder;
                        input.setAttribute('aria-label', 'Other answer');
                        input.classList.add('ph-option');
                        input.style.padding = '0px';
                        input.style.minHeight = '20px';
                        input.style.backgroundColor = 'transparent';
                        answerOption.appendChild(input);

                        input.addEventListener('input', () => {
                            if (input.value) {
                                let errorElement = this.ctx.getById(this.shadowRoot, 'errorElement' + this.question.id);
                                errorElement.classList.remove('ph-error');
                                errorElement.textContent = '';
                                this.clearAriaInvalid(this.answerContainer);
                            }
                            if (radioButton.checked && input.value) {
                                answer[0] = input.value;
                                answerName = option.name;
                                radioButton.value = input.value;
                            }
                        });

                        let btnElement = this.ctx.getById(this.shadowRoot, 'btnElement' + this.question.id);
                        let nextButton = document.createElement('button');
                        nextButton.classList.add('ph-btn--primary');
                        nextButton.textContent = this.question.buttonName;
                        nextButton.onclick = () => {
                            if (!input.value) {
                                let errorElement = this.ctx.getById(this.shadowRoot, 'errorElement' + this.question.id);
                                errorElement.classList.add('ph-error');
                                errorElement.textContent = this.question.errorText;
                                this.setAriaInvalid(this.answerContainer);
                            } else {
                                let errorElement = this.ctx.getById(this.shadowRoot, 'errorElement' + this.question.id);
                                errorElement.classList.remove('ph-error');
                                errorElement.textContent = '';
                                this.clearAriaInvalid(this.answerContainer);

                                this.ctx.goNext(this.question, answer[0]);
                            }
                        };
                        btnElement.appendChild(nextButton);
                    }
                };
                internalBox.appendChild(answerOption);
            }
        });

        return answerOptionsElement;
    }
}
